@include host-component-properties;

:host {
  --paf-result-timetable-row-padding: var(--paf-global-spacing-fixed-3x);
  --paf-result-timetable-row-font-size: 14;
  --paf-result-timetable-row-transition: 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  --paf-result-timetable-row-column-gap: var(--paf-global-spacing-fixed-8x);

  @include mq($from: small) {
    --paf-result-timetable-row-padding: var(--paf-global-spacing-fixed-4x);
    --paf-result-timetable-row-font-size: #{$components-base-font-size};
  }

  @include mq($from: wide) {
    --paf-result-timetable-row-column-gap: var(--paf-global-spacing-fixed-10x);
  }
}

.result-timetable-row {
  position: relative;
  font-size: px-to-rem(var(--paf-result-timetable-row-font-size));
  color: var(--paf-global-post-brand-black);
  outline: px-to-rem(var(--paf-global-border-width-1x)) solid var(--paf-global-post-brand-gray);
  transition: outline-color var(--paf-result-timetable-row-transition);

  &.loading {
    pointer-events: none;
  }

  &.loading:only-child {
    margin-block-end: px-to-rem(var(--paf-global-spacing-fixed-2x));
  }

  @include reduced-motion {
    transition: none;
  }

  &:has(.result-timetable-row__button:hover),
  &:has(.result-timetable-row__button:focus) {
    outline-color: var(--paf-global-post-brand-light);
  }

  &:has(.result-timetable-row__button--expanded),
  &:has(.result-timetable-row__button--expanded:hover),
  &:has(.result-timetable-row__button--expanded:focus) {
    outline-color: var(--paf-global-post-brand-secondary);
  }
}

.result-timetable-row__heading {
  @include screen-reader-only;
}

.result-timetable-row__visual {
  display: flex;
  align-items: center;
  column-gap: px-to-rem(var(--paf-result-timetable-row-column-gap));
  padding: px-to-rem(var(--paf-result-timetable-row-padding));
  background: var(--paf-global-post-brand-gray);
  transition: background-color var(--paf-result-timetable-row-transition);

  @include reduced-motion {
    transition: none;
  }
}

.result-timetable-row__visual-inner-wrapper {
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  row-gap: px-to-rem(var(--paf-global-spacing-fixed-3x));
  max-width: 100%;
}

.result-timetable-row__button {
  @include button-reset;

  position: absolute;
  inset: 0;
  z-index: 2;
  background: none;
  cursor: pointer;
  scroll-margin-block-start: px-to-rem(var(--paf-global-spacing-fixed-2x));

  &:focus-visible,
  &:focus-within,
  &:hover {
    outline-offset: 0;

    @include forced-colors {
      outline-offset: px-to-rem(var(--paf-global-spacing-fixed-1x));
    }

    & + .result-timetable-row__visual {
      background: var(--paf-global-post-brand-light);

      @include forced-colors {
        border-radius: px-to-rem(var(--paf-global-spacing-fixed-1x));
      }
    }
  }
}

.result-timetable-row__button--expanded {
  & + .result-timetable-row__visual {
    outline-color: var(--paf-global-post-brand-secondary);
  }
}

::slotted([slot="buy-button"]) {
  display: block;
  z-index: 2;

  .loading & {
    display: none;
  }

  @include mq($to: large) {
    display: none;
  }
}

::slotted([slot="price-badge"]) {
  position: absolute;
  z-index: 1;
  inset-inline-end: 0;
  inset-block-start: 0;
}
